import { create } from 'zustand';

const useRouteStore = create((set) => ({
  route: [],
  setRoute: (route) => set({ route }),
}));

export default useRouteStore;
